var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.6673V1.33398Z",
    fill: "#304059"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.6673V1.33398",
    stroke: "#304059",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33398 8H14.6673Z",
    fill: "#304059"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33398 8H14.6673",
    stroke: "#304059",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIconBlue);
export default __webpack_public_path__ + "static/media/addIconBlue.7d1ccc22876525811b01075d0fa1db0c.svg";
export { ForwardRef as ReactComponent };